module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chip"
  }, [_vm._v("\n  " + _vm._s(_vm.title) + "\n  "), _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        return _vm.remove(_vm.title)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-394b17c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAChip.vue
// module id = 694
// module chunks = 0